import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Dumbbell, Stethoscope, ClipboardCheck } from 'lucide-react';
export function BonusesSection() {
  const bonuses = [{
    title: 'Guía de Ejercicios Inteligentes según Diagnóstico',
    desc: 'Ejercicios clasificados por problema (lumbar, rodilla, hombro), según déficit y nivel del paciente. Con progresiones paso a paso y errores comunes.',
    icon: <Dumbbell className="w-8 h-8 text-amber-400" data-id="element-23" />,
    perception: '"Dejá de adivinar qué ejercicio usar"'
  }, {
    title: 'Casos Clínicos Resueltos (Paso a Paso)',
    desc: 'Casos reales de dolor lumbar, rodilla, hombro y más. Con evaluación completa, diagnóstico funcional y plan de tratamiento.',
    icon: <Stethoscope className="w-8 h-8 text-amber-400" data-id="element-24" />,
    perception: '"Ahora sí sé qué hacer con un paciente"'
  }, {
    title: 'Guía Rápida de Evaluación',
    desc: 'Paso a paso de evaluación, tests clave resumidos, qué observar en cada fase y errores comunes a evitar.',
    icon: <ClipboardCheck className="w-8 h-8 text-amber-400" data-id="element-25" />,
    perception: '"No me voy a olvidar de nada nunca más"'
  }];
  return <section className="py-16 px-4 bg-gradient-to-b from-slate-900 to-slate-950 border-t border-slate-800" data-id="element-26">
      <div className="max-w-4xl mx-auto" data-id="element-27">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-28">
          <div className="inline-flex items-center justify-center p-3 bg-amber-500/10 rounded-full mb-4 border border-amber-500/30" data-id="element-29">
            <Gift className="w-10 h-10 text-amber-500" data-id="element-30" />
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-white mb-2" data-id="element-31">
            Bonos Exclusivos
          </h2>
          <p className="text-xl text-amber-400 font-bold" data-id="element-32">
            Llevate todo esto GRATIS por el día de hoy
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-33">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-slate-900 border border-amber-900/30 p-5 rounded-xl flex items-start gap-4 relative overflow-hidden group hover:border-amber-500/40 transition-colors" data-id="element-34">
              <div className="bg-slate-950 p-3 rounded-lg border border-slate-800 flex-shrink-0" data-id="element-35">
                {bonus.icon}
              </div>
              <div className="flex-1 min-w-0" data-id="element-36">
                <div className="flex items-center gap-3 flex-wrap mb-1" data-id="element-37">
                  <h3 className="text-lg font-bold text-white" data-id="element-38">
                    {bonus.title}
                  </h3>
                  <span className="bg-amber-500 text-slate-950 text-[10px] font-black px-2 py-0.5 rounded-full uppercase tracking-wider whitespace-nowrap" data-id="element-39">
                    Gratis hoy
                  </span>
                </div>
                <p className="text-slate-400 text-sm mb-2" data-id="element-40">{bonus.desc}</p>
                <p className="text-amber-400/80 text-sm font-medium italic" data-id="element-41">
                  👉 {bonus.perception}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}